const api = require('../Services/creds.json');

export default function JSNotification(DivStatus, BtnToggleSubscribed, DivSubscription, jurorID) {
    function element(elem) {
        return typeof elem !== 'string' ? elem : document.getElementById(elem);
    }

    const divStatus = element(DivStatus);
    const divSubscription = element(DivSubscription);
    const btnToggleSubscribed = element(BtnToggleSubscribed);

    let Registration = null;
    /**
     * @type {PushSubscription}
     */
    let Subscription = null;
    //* * get notification public key from cred.json (first) */
    let PublicKey = api.vapidPublicKey;
    //* * check .env  */
    if (process.env.REACT_APP_vapidPublicKey) {
        PublicKey = process.env.REACT_APP_vapidPublicKey;
    }

    function log(logMessage, div) {
        // eslint-disable-next-line no-console
        console.log(`[JSNotification] ${logMessage}`);
        const newDiv = div;
        if (div) newDiv.innerHTML = logMessage;
    }

    function logState(item, stateStatus, stateName, div) {
        if (stateStatus) log('');
        else log(`${item} is${stateStatus === false ? ' NOT' : '???'} ${stateName}.`, div);
    }

    function logSupported(item, supported) {
        logState(item, supported, 'supported');
    }

    function toString() {
        return '[object JSNotification]';
    }
    this.toString = toString;

    async function setSubscription() {
        divSubscription.innerHTML = `Subcription JSON to send to API:<br/>${JSON.stringify(Subscription)}`;
        divSubscription.style.display = Subscription ? 'block' : 'none';
        btnToggleSubscribed.update();
    }

    async function postPushSubscription() {
        log('Saving subscription to database...');
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                jurorID: jurorID,
                subscription: JSON.stringify(Subscription)
            })
        };
        await fetch(`${api.baseurl}jurorManagement/postPushSubscription`, requestOptions)
            .then(() => log('Subscription saved.'))
            .catch((error) => log(`Error saving subscription: ${error}`));
    }

    function urlB64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; i += 1) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    async function subscribeUser() {
        let result = false;
        log('Attempting to subscribe user...');

        await Registration.pushManager
            .subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlB64ToUint8Array(PublicKey)
            })
            .then((subscription) => {
                Subscription = subscription;
                result = true;
            })
            .catch(() => {
                log('Failed to subscribe the user.');
            })
            .finally(() => logState('User', !!Subscription, 'subscribed for notifications', divStatus));

        return result;
    }

    btnToggleSubscribed.update = () => {
        btnToggleSubscribed.textContent = !Subscription ? 'Subscribe' : 'Unsubscribe';
    };

    async function registerServiceWorker() {
        log('Registering service worker...');
        let registered = null;
        await navigator.serviceWorker
            .register('sw.js')
            .then((swReg) => {
                // eslint-disable-next-line no-global-assign
                Worker = swReg.installing || swReg.waiting || swReg.active;
                Registration = swReg;
                registered = true;
            })
            .catch(() => {
                log('Error registering service worker.');
                registered = false;
            })
            .finally(() => {
                logState('Service Worker', registered, 'registered');
            });
        return registered;
    }

    async function checkSubscription() {
        let result = false;
        log('Checking subscription...');

        await Registration.pushManager
            .getSubscription()
            .then((subscription) => {
                Subscription = subscription;
                btnToggleSubscribed.update();
                logState('User', !!Subscription, 'subscribed for notifications', divStatus);
                result = true;
            })
            .catch(() => {
                log('Error checking push subscription.');
            });

        return result;
    }

    function unsubscribeUser() {
        log('unsubscribing user...');
        Subscription.unsubscribe()
            .then(() => setSubscription(null))
            .catch(() => {
                log('Failed to unsubscribe the user.');
            })
            .finally(() => {
                logState('User', !!Subscription, 'subscribed for notifications', divStatus);
                btnToggleSubscribed.update();
            });
    }

    btnToggleSubscribed.onclick = () => (Subscription === null ? subscribeUser() : unsubscribeUser());

    function checkPushNotficationsSupported() {
        log('Checking push notifications support...');
        const serviceWorkerSupported = 'serviceWorker' in navigator;
        logSupported('Service Worker', serviceWorkerSupported);

        const pushManagerSupported = 'PushManager' in window;
        logSupported('Push Manager', pushManagerSupported);

        const supported = serviceWorkerSupported && pushManagerSupported;
        logSupported('Push Notifications', supported);
        return supported;
    }

    async function init() {
        if (!checkPushNotficationsSupported()) return;
        if (!(await registerServiceWorker())) return;
        if (!(await checkSubscription())) return;
        if (!Subscription) {
            if (await subscribeUser()) await postPushSubscription();
        }
        setSubscription();
    }

    init();
}
